import React from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { AudioOptionButtonState } from './AudioOptionButton.const';
import { StyledAudioOption, StyledButton } from './AudioOptionButton.style';

interface Props {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  translationId: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  buttonState: AudioOptionButtonState;
}

const AudioOptionButton: React.FC<Props> = ({ Icon, translationId, onClick, buttonState }) => {
  const colors = useSelector(colorsSelector);

  return (
    <StyledAudioOption {...{ buttonState, colors }} >
      <StyledButton {...{ buttonState, onClick, colors }}>
        <Icon fontSize='inherit' width={30} height={30} />
      </StyledButton>
      <FormattedMessage id={translationId} />
    </StyledAudioOption>
  );
};

export default AudioOptionButton;
